module.exports = __webpack_public_path__ + "img/canvasMenuEnd.65589597.svg";